"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          align-items: center;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WrapperStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var center = _ref.center;
  return center ? (0, _uiKit.css)(_templateObject2()) : "";
});
exports.WrapperStyled = WrapperStyled;